import styles from './SiderToggler.module.scss';
import { Fragment } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { MenuFoldOutlined, MenuUnfoldOutlined } from '@ant-design/icons';
import { collapseSider, expandSider } from '../../../../redux/actions/sider-menu';

const SiderToggler = () => {
    const dispatch = useDispatch();

    const collapsed = useSelector(state => state.siderMenu.isSiderCollapsed);

    const onCollapse = () => {
        dispatch(collapseSider());
        localStorage.setItem('sider', 'collapsed');
    };

    const onExpand = () => {
        dispatch(expandSider());
        localStorage.setItem('sider', 'expanded');
    };

    return (
        <Fragment>
            {collapsed ? (
                <MenuUnfoldOutlined className={styles.toggler} onClick={onExpand} />
            ) : (
                <MenuFoldOutlined className={styles.toggler} onClick={onCollapse} />
            )}
        </Fragment>
    );
};

export default SiderToggler;
